
import { ROLE } from "@/api/firebase";
import { UserData } from "@/models/User";
import { AdminData } from "@/models/AdminData";
import { Component, Vue } from "vue-property-decorator";

@Component({})
class AdminUtil extends Vue {
  uidInfo = {
    uid: "",
    valid: null,
    responseMsg: "",
    errorMsg: "",
  };

  debugInfo = {
    uid: "",
    valid: null,
    responseMsg: "",
    errorMsg: "",
  } as AdminData;

  testerAccess = {
    uid: "",
    valid: null,
    responseMsg: "",
    errorMsg: "",
  } as AdminData;

  adminAccess = {
    uid: "",
    valid: null,
    responseMsg: "",
    errorMsg: "",
  } as AdminData;

  revokeAccessInfo = {
    uid: "",
    valid: null,
    responseMsg: "",
    errorMsg: "",
  } as AdminData;

  get getUserData(): UserData {
    return this.$store.state.authenication.userData;
  }

  get getHeader(): string {
    if (this.getUserData.role === ROLE.SUPERADMIN) {
      return "Superadmin tools";
    } else if (this.getUserData.role === ROLE.ADMIN) {
      return "Admin tools";
    } else {
      return "";
    }
  }

  async promoteDebug(): Promise<void> {
    let arrayUid: string[] = [];
    arrayUid.push(this.debugInfo.uid);
    this.$store
      .dispatch("toolBoxStore/sendUserRole", {
        uid: arrayUid,
        role: ROLE.DEBUG,
      })
      .then((results) => {
        this.debugInfo.uid = "";
        this.debugInfo.errorMsg = "";
        this.debugInfo.responseMsg = results.data;
      })
      .catch((error) => {
        this.debugInfo.errorMsg = error.message;
        this.debugInfo.responseMsg = "";
      });
  }

  async promoteInAppTester(): Promise<void> {
    let arrayUid: string[] = [];
    arrayUid.push(this.testerAccess.uid);
    this.$store
      .dispatch("toolBoxStore/sendUserRole", {
        uid: arrayUid,
        role: ROLE.TESTER,
      })
      .then((results) => {
        this.testerAccess.uid = "";
        this.testerAccess.errorMsg = "";
        this.testerAccess.responseMsg = results.data;
      })
      .catch((error) => {
        this.testerAccess.errorMsg = error.message;
        this.testerAccess.responseMsg = "";
      });
  }
  async promoteAdmin(): Promise<void> {
    let arrayUid: string[] = [];
    arrayUid.push(this.adminAccess.uid);
    this.$store
      .dispatch("toolBoxStore/sendUserRole", {
        uid: arrayUid,
        role: ROLE.ADMIN,
      })
      .then((results) => {
        this.adminAccess.uid = "";
        this.adminAccess.errorMsg = "";
        this.adminAccess.responseMsg = results.data;
      })
      .catch((error) => {
        this.adminAccess.errorMsg = error.message;
        this.adminAccess.responseMsg = "";
      });
  }

  async revokeAccess(): Promise<void> {
    let arrayUid: string[] = [];
    arrayUid.push(this.revokeAccessInfo.uid);
    this.$store
      .dispatch("toolBoxStore/sendUserRole", {
        uid: arrayUid,
        role: ROLE.NONE,
      })
      .then((results) => {
        this.revokeAccessInfo.uid = "";
        this.revokeAccessInfo.errorMsg = "";
        this.revokeAccessInfo.responseMsg = results.data;
      })
      .catch((error) => {
        this.revokeAccessInfo.errorMsg = error.message;
        this.revokeAccessInfo.responseMsg = "";
      });
  }

  addCenterPointScript(): void {
    this.$store.dispatch(
      "cityStore/addCenterPointScript",
      this.$store.state.cityStore.city
    );
  }
}

export default AdminUtil;
